<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>物料管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">公司物料</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInAddShow && !hideInEditShow">
      <section class="searchBox">
        <span class="addStyle">
          <a-button
            type="primary"
            icon="plus"
            @click="hideInAddShow = !hideInAddShow"
            >增加</a-button
          >
        </span>
        <span>
          <label>字符串：</label>
          <div>
            <a-input
              placeholder="请输入物料名称"
              v-model="query_field"
              style="margin-right:20px;"
            />
          </div>
        </span>
        <span>
          <a-button @click="reactPage" style="margin-right:10px;"
            >重置</a-button
          >
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.name }}</td>
              <td>
                <p v-show="item.type == 1">工具</p>
                <p v-show="item.type == 2">消耗品</p>
              </td>
              <td>{{ Number(item.price) + "元" }}</td>
              <td>
                {{
                  Number(item.double_consume) == 0
                    ? ""
                    : Number(item.double_consume) + item.unit
                }}
              </td>
              <td>
                {{
                  Number(item.total_out) == 0
                    ? ""
                    : Number(item.total_out) + item.unit
                }}
              </td>
              <td>
                {{
                  Number(item.guard_surplus) == 0
                    ? ""
                    : Number(item.guard_surplus) + item.unit
                }}
              </td>
              <td>
                {{
                  Number(item.total_in) == 0
                    ? ""
                    : Number(item.total_in) + item.unit
                }}
              </td>
              <td>
                {{
                  Number(item.company_surplus) == 0
                    ? ""
                    : Number(item.company_surplus) + item.unit
                }}
              </td>
              <td class="operation">
                <a style="color:#67C23A" @click="edit(item)">编辑</a>
                <a @click="warehouseEntering(item)">入库</a>
                <a style="color:#F56C6C" @click="warehouseOut(item)">出库</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>

    <!-- 增加 -->
    <addMaterial v-on:hideInAdd="hideInAdd" v-show="hideInAddShow" />
    <!-- 增加 end-->
    <!-- 编辑 -->
    <materialEdit
      v-show="hideInEditShow"
      :editDetail="editDetail"
      v-on:hideInEdit="hideInEdit"
    />
    <!-- 编辑 edn -->
    <!-- 入库 -->
    <aside class="dialogsBox" v-show="warehouseIsShow">
      <div>
        <h3>入库</h3>
        <ul v-if="warehouseDetail">
          <li>
            <label>物料名称：</label>
            <p>{{ warehouseDetail.name }}</p>
          </li>
          <li>
            <label> <i>*</i>入库数量： </label>
            <a-input-number v-model="number" :min="1" />
            <span>{{ "&nbsp;" + warehouseDetail.unit }}</span>
          </li>
        </ul>
        <div>
          <a-button @click="resetWarehouse">取消</a-button>
          <a-button type="primary" @click="submitWarehouse">提交</a-button>
        </div>
      </div>
    </aside>
    <!-- 入库 end -->
    <!-- 出库 -->
    <aside class="dialogsBox" v-show="warehouseOutIsShow">
      <div>
        <h3>出库</h3>
        <ul v-if="warehouseOutDetail">
          <li>
            <label>物料名称：</label>
            <p>{{ warehouseOutDetail.name }}</p>
          </li>
          <li>
            <label> <i>*</i>出库数量： </label>
            <a-input-number v-model="numberOut" :min="1" />
            <span>{{ "&nbsp;" + warehouseOutDetail.unit }}</span>
          </li>
          <li>
            <label> <i>*</i>员工： </label>
            <a-select
              show-search
              style="width: 200px"
              v-model="user_id"
              :filter-option="filterOption"
            >
              <a-select-option
                v-for="(element, k) in userList"
                :key="k"
                :value="element.id"
                >{{
                  element.user_name + "&nbsp;" + element.phone
                }}</a-select-option
              >
            </a-select>
          </li>
        </ul>
        <div>
          <a-button @click="resetWarehouseOut">取消</a-button>
          <a-button type="primary" @click="submitWarehouseOut">提交</a-button>
        </div>
      </div>
    </aside>
    <!-- 出库  end -->
  </div>
</template>
<script>
import axios from "axios";
import addMaterial from "@/components/clean/addMaterial"; //增加
import materialEdit from "@/components/clean/materialEdit"; //编辑
export default {
  components: {
    addMaterial,
    materialEdit
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      typeSearch: -1,
      hideInEditShow: false,
      editDetail: {},
      totalPage: Number,
      thList: [
        "物料名称",
        "类型",
        "单价",
        "双周工单消耗",
        "总出库",
        "员工现存",
        "总入库",
        "公司现存",
        "操作"
      ],
      warehouseDetail: {},
      warehouseIsShow: false,
      number: "",
      warehouseOutDetail: "",
      warehouseOutIsShow: false,
      numberOut: "",
      userList: [],
      user_id: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getUser(); //获取员工
  },
  methods: {
    getUser() {
      let url =
        this.httpsBasic.url + this.httpsBasic.clean + "Guard/guardListData";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.userList = res.data.data.data;
            // console.log(this.userList);
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    warehouseOut(val) {
      this.warehouseOutDetail = val;
      this.warehouseOutIsShow = true;
    },
    resetWarehouseOut() {
      this.numberOut = "";
      this.user_id = "";
      this.warehouseOutIsShow = false;
    },
    submitWarehouseOut() {
      if (this.numberOut != "" && this.user_id != "") {
        let _this = this;
        this.warehouseOutIsShow = false;
        this.$confirm({
          title: "提示",
          content: "一旦提交，物料将出库给对应员工，确认无误后进行操作",
          onOk() {
            _this.httpWarehouseOut();
          }
        });
      } else {
        this.$message.error("标记*为必填项！");
      }
    },
    httpWarehouseOut() {
      let url =
        this.httpsBasic.url + this.httpsBasic.clean + "Material/outMaterial";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        number: this.numberOut,
        clean_material_id: this.warehouseOutDetail.id,
        user_id: this.user_id
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("出库成功");
            this.numberOut = "";
            this.user_id = "";
            this.reload();
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错了...");
        });
    },
    warehouseEntering(val) {
      this.warehouseDetail = val;
      this.warehouseIsShow = true;
    },
    resetWarehouse() {
      this.warehouseIsShow = false;
      this.number = "";
    },
    submitWarehouse() {
      if (this.number != "") {
        let _this = this;
        this.warehouseIsShow = false;
        this.$confirm({
          title: "提示",
          content: "一旦提交，系统将进行物料入库，确认无误后进行操作",
          onOk() {
            _this.httpWarehouse();
          }
        });
      } else {
        this.$message.error("标记*为必填项！");
      }
    },
    httpWarehouse() {
      let url =
        this.httpsBasic.url + this.httpsBasic.clean + "Material/inMaterial";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        number: this.number,
        clean_material_id: this.warehouseDetail.id
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("入库成功");
            this.number = "";
            this.reload();
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错了...");
        });
    },
    reactPage() {
      this.query_field = "";
      this.page = 1;
      this.getData();
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddShow = msg;
      this.reload();
    },
    hideInEdit(msg) {
      this.hideInEditShow = msg;
      this.reload();
    },
    showInUserList() {
      this.hideInAddShow = false;
      this.hideInEditShow = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "Material/companyMaterialList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(item) {
      console.log(item);
      this.hideInEditShow = true;
      this.editDetail = item;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.areaStyle {
  p {
    display: inline-block;
  }
}
.listContainer {
  .searchBox {
    display: block;
    .addStyle {
      margin-right: 24%;
    }
    > span {
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 10px;
      > div {
        display: inline-block;
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
